<template>
  <div class="flex min-h-dvh w-full justify-center">
    <slot />
  </div>
</template>
